import type { PaymentModuleId } from '@foundation/apis/payments';

import { Paragraph, PaymentIcon } from '@/components/common';
import { useUserFriendlyPaymentModuleName } from '@/hooks/useUserFriendlyPaymentModuleName';
import { InstrumentIconForModuleId } from '@/services/payments/instruments/PaymentInstrumentTypes';

interface INewPaymentMethodProps {
  readonly moduleId: PaymentModuleId;
}

export function NewPaymentMethod({ moduleId }: INewPaymentMethodProps) {
  const paymentModuleT = useUserFriendlyPaymentModuleName();

  return (
    <div className="w-full flex flex-row items-center space-x-sm">
      <PaymentIcon icon={InstrumentIconForModuleId[moduleId]} />
      <Paragraph ellipsisOnOverflow>{paymentModuleT(moduleId)}</Paragraph>
    </div>
  );
}
